






import { BaseElement } from '@/api/com/MetaPattern/MDA/MD/Base/BaseElement';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class PGRowElementSelect extends Vue {
  @Prop() private value!: string;
  @Prop() private isEditable!: boolean;
  @Prop() private options!: any;
  private textValue!: string;

  constructor() {
    super();
    this.textValue = this.value;
  }

  saveChange(): void {
    this.$emit('valueChanged', this.textValue, this.options.find((item: BaseElement) => item.id === this.textValue));
  }

  @Watch('value')
  refresh() {
    this.textValue = this.value;
  }
}
